module.exports = __webpack_public_path__ + "static/media/arrowLeft.34ba2a62.png";